export const sessionTokenLsKeyword = 'dottv: sessionToken'
export const refreshTokenKeyword = 'dottv: refreshToken'
export const lastTimeStart = 'dottv: lastTimeStart'

export const getFromLocalStorage = (keyword: string) => {
    const stringifiedConfig = localStorage.getItem(keyword)
    return stringifiedConfig
}
export const saveToLocalStorage = (keyword: string, value: string) => {
    if (value) {
        localStorage.setItem(keyword, value)
    }
}
export const removeFromLocalStorage = (keyword: string) => {
    localStorage.removeItem(keyword)
}
